'use strict';

var text = require('./text');

module.exports = raw;

/* Stringify `raw`. */
function raw(ctx, node) {
  return ctx.dangerous ? node.value : text(ctx, node);
}



//////////////////
// WEBPACK FOOTER
// ./~/hast-util-to-html/lib/raw.js
// module id = 183
// module chunks = 96961042003272 139266963665775